import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/**
 * LineClamp
 *
 * Drop-in replacement for `react-trunk8`. Truncates its text children to a
 * maximum number of lines and appends a trailing ellipsis, using native CSS
 * `-webkit-line-clamp`. No JS measurement and no external dependencies, so it
 * is fully compatible with React 19.
 */
const LineClamp = memo(({ lines = 1, children, className, style, ...props }) => {
    const clampStyle = useMemo(
        () => ({
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: lines,
            overflow: 'hidden',
            wordBreak: 'break-word',
            ...style,
        }),
        [lines, style],
    );

    return (
        <div className={className} style={clampStyle} {...props}>
            {children}
        </div>
    );
});

LineClamp.displayName = 'LineClamp';

LineClamp.propTypes = {
    lines: PropTypes.number,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default LineClamp;
